<template>
  <div>
    <div class="app-container" style="height: calc(100vh - 130px);overflow-y: auto;">
      <el-form
        ref="form"
        :model="queryForm"
        size="small"
        :label-position="$i18n.locale !== 'zh' ? 'top' : 'right'"
        :label-width="$i18n.locale !== 'zh' ? 'auto' : '160px'"
      >
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item>
              <template slot="label">
                <el-select v-model="queryForm.numberField" :placeholder="$t('operationCenter.PleaseSelect')">
                  <el-option
                    v-for="item in ORDER_TYPE"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
              </template>
              <el-input
                v-model="numberList"
                :placeholder="$t('newOrder.PreciseSearch').replace('200', 20000 + '')"
                :rows="4"
                type="textarea"
              />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <div class="grid-content bg-purple">
              <el-form-item :label="$t('trajectory.TransitTime')">
                <!--运输时间-->
                <el-date-picker
                  v-model="queryDate"
                  :default-time="['00:00:00', '23:59:59']"
                  :end-placeholder="$t('operationCenter.endDate')"
                  :picker-options="dateLimit"
                  :range-separator="$t('operationCenter.to')"
                  :start-placeholder="$t('operationCenter.startDate')"
                  style="width: 100%"
                  type="datetimerange"
                  value-format="yyyy-MM-dd HH:mm:ss"
                />
              </el-form-item>
            </div>
          </el-col>
          <el-col :span="24">
            <el-form-item>
              <template slot="label">
                <el-select v-model="queryForm.customerIdField" :placeholder="$t('operationCenter.PleaseSelect')">
                  <el-option
                    v-for="item in CUSTOMER_TYPE"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
              </template>
              <el-input
                v-model="queryForm.customerName"
                :placeholder="$t('模糊匹配')"
              />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <!--车型-->
            <el-form-item :label="$t('vehicle.modelLabel')">
              <el-select
                v-model="queryForm.vehicleType"
                :placeholder="$t('operationCenter.PleaseSelect')"
                clearable
                filterable
                style="width: 100%;"
              >
                <el-option
                  v-for="item in modelList"
                  :key="item.dictValue"
                  :label="item.dictLabel"
                  :value="item.dictValue"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <!--装卸类型-->
            <el-form-item :label="$t('basicData.UnloadingType')">
              <el-select
                v-model="queryForm.loadingType"
                :placeholder="$t('operationCenter.PleaseSelect')"
                clearable
                filterable
                style="width: 100%;"
              >
                <el-option
                  v-for="item in locationType"
                  :key="item.dictValue"
                  :label="item.dictLabel"
                  :value="item.dictValue"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <!--付款方式-->
            <el-form-item :label="$t('basicData.PaymentMethod')">
              <el-select
                v-model="queryForm.paymentMethod"
                :placeholder="$t('operationCenter.PleaseSelect')"
                clearable
                filterable
                style="width: 100%;"
              >
                <el-option
                  v-for="item in paymentMethod"
                  :key="item.dictValue"
                  :label="item.dictLabel"
                  :value="item.dictValue"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <!--对账状态-->
            <el-form-item :label="$t('receivablePayable.ReconciliationStatus')">
              <el-select
                v-model="queryForm.isGenBill"
                :placeholder="$t('operationCenter.PleaseSelect')"
                clearable
                filterable
                style="width: 100%;"
              >
                <!--是-->
                <el-option :label="$t('GlobalSetObj.yes')" :value="1" />
                <!--否-->
                <el-option :label="$t('GlobalSetObj.No')" :value="0" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <!--核收状态-->
            <el-form-item :label="$t('basicData.VerificationStatus')">
              <el-select
                v-model="queryForm.isAccept"
                :placeholder="$t('operationCenter.PleaseSelect')"
                clearable
                filterable
                style="width: 100%;"
              >
                <!--是-->
                <el-option :label="$t('GlobalSetObj.yes')" :value="1" />
                <!--否-->
                <el-option :label="$t('GlobalSetObj.No')" :value="0" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col v-if="selectKey === 1" :span="24">
            <div class="grid-content bg-purple">
              <!--批次号-->
              <el-form-item :label="$t('basicData.BatchNo')" prop="billBatchNumber">
                <el-input v-model="queryForm.billBatchNumber" :disabled="isReadOnly" />
              </el-form-item>
            </div>
          </el-col>
          <el-col v-if="selectKey === 2" :span="24">
            <div class="grid-content bg-purple">
              <!--收款单号-->
              <el-form-item :label="$t('basicData.ReceiptNumber')" prop="receiptNumber">
                <el-input v-model="queryForm.receiptNumber" :disabled="isReadOnly" />
              </el-form-item>
            </div>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div style="text-align: center;border-top: 1px solid #ccc;padding-top: 10px;">
      <!--查 询-->
      <el-button size="small" type="primary" @click="searchForm">{{ $t('basicData.Search') }}</el-button>
      <!--重 置-->
      <el-button size="small" type="success" @click="onReset">{{ $t('basicData.reset') }}</el-button>
      <!--取 消-->
      <el-button size="small" @click="onClose">{{ $t('basicData.Cancel') }}</el-button>
    </div>
  </div>
</template>

<script>
import { cloneDeep } from 'lodash-es';
import { getTextareaVal } from '@/views/finance/basicData/PriceInquiryLog/utils.js';
import { beforeSearch } from '@/views/finance/payableManage/feesPayable/enums';
import { ORDER_TYPE, CUSTOMER_TYPE } from '../utils';
import { GlobalSetObj } from '@/lang/type/global';
const params = {
  numberField: 'order_number',
  customerIdField: 'order_customer',
  customerName: '',
  startTime: '',
  endTime: '',
  vehicleType: '',
  paymentMethod: '',
  loadingType: '',
  isAccept: null,
  isGenBill: null
};
export default {
  name: 'SearchForm',
  props: {
    // 对账单/收款单禁用
    isReadOnly: {
      type: Boolean,
      default: false
    },
    // 条件类型 1: 对账单 2: 收款单
    selectKey: {
      type: Number,
      default: 1
    },
    // 对账单/收款单
    billBatchNumber: {
      type: String,
      default: ''
    },
    // 车型
    modelList: {
      type: Array,
      default: () => []
    },
    // 付款方式
    paymentMethod: {
      type: Array,
      default: () => []
    },
    // 装卸类型
    locationType: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      ORDER_TYPE,
      CUSTOMER_TYPE,
      queryForm: {
        ...params
      },
      queryDate: [], // 查询日期区间
      numberList: '', // 单号
      // 日期限制
      pickerMinDate: '',
      pickerRange: 30 * 24 * 60 * 60 * 1000 // 可选择日期范围 为15天
    };
  },

  computed: {
    GlobalSetObj() {
      return GlobalSetObj;
    },
    /**
     * 日期限制处理
     *    默认情况下限制15天
     *    如果输入了 业务单号 或 客户单号 或 批次号，则不限制时间
     */
    dateLimit() {
      const { numberList, pickerMinDate, pickerRange } = this;
      const { billBatchNumber, receiptNumber } = this.queryForm;

      // 默认限制30天
      return {
        // 设置不能选择的日期
        onPick: ({ minDate }) => {
          // 输入了内容
          if (numberList || billBatchNumber || receiptNumber) {
            // 取消限制
            this.pickerMinDate = null;
            return;
          }

          if (minDate && pickerMinDate) {
            this.pickerMinDate = null;
          } else if (minDate) {
            this.pickerMinDate = minDate.getTime();
          }
        },
        disabledDate: (time) => {
          // 输入了内容
          if (numberList || billBatchNumber || receiptNumber) {
            // 取消时间限制
            return false;
          }

          if (this.pickerMinDate) {
            return (time.getTime() > (pickerMinDate + pickerRange)) || (time.getTime() < (pickerMinDate - pickerRange));
          }
          return false;
        }
      };
    }
  },
  created() {
    // 根据selectKey的值，决定是赋值给billBatchNumber还是receiptNumber
    if (this.selectKey) {
      this.queryForm[this.selectKey === 1 ? 'billBatchNumber' : 'receiptNumber'] = this.billBatchNumber;
    }
  },

  methods: {
    // 取消
    onClose() {
      this.$emit('close');
    },
    // 重置
    onReset() {
      this.numberList = '';
      this.queryDate = [];
      this.queryForm = {
        ...params
      };
      if (!this.selectKey) return;
      this.queryForm[this.selectKey === 1 ? 'billBatchNumber' : 'receiptNumber'] = this.billBatchNumber;
    },
    // 搜索
    searchForm() {
      const params = cloneDeep(this.queryForm);

      if (this.queryDate && this.queryDate.length > 1) {
        const start = new Date(this.queryDate[0]).getTime();
        const end = new Date(this.queryDate[1]).getTime();
        if (start > end) {
          this.$message.warning(this.$t('receivablePayable.TheStartTimeCannotBeGreaterThanTheEndTime')); // 起始时间不能大于结束时间
          return;
        }
        params.startTime = this.queryDate[0];
        params.endTime = this.queryDate[1];
      } else {
        params.startTime = '';
        params.endTime = '';
      }
      // 字段截取
      params.numberList = getTextareaVal(this.numberList, 20000);

      // 校验时间和单号二选一
      {
        const isBool = beforeSearch(params);
        if (!isBool) {
          this.$message.warning(this.$t('receivablePayable.BusinessTimeOrOrderNumberCannotBeEmpty'));
          return;
        }
      }

      if (params.numberList.length > 20000) {
        return this.$message.warning(this.$t('receivablePayable.TheInputTrackingNumberCannotExceed30000Lines').replace('30000', 20000 + ''));
      }

      this.$emit('search', params);
    }
  }
};
</script>

